import { render, staticRenderFns } from "./SizesSwitcher.vue?vue&type=template&id=813dc826&lang=pug"
import script from "./SizesSwitcher.vue?vue&type=script&lang=js"
export * from "./SizesSwitcher.vue?vue&type=script&lang=js"
import style0 from "./SizesSwitcher.vue?vue&type=style&index=0&id=813dc826&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports